var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvenements(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m95.6,67.52l-20.53-20.53-2.66,2.66,17.88,17.88H27.48l-8.14-8.14,31.4-31.4,19.01,19.01,2.66-2.66L36.72,8.64,0,45.36l22.16,22.16h-10.12v51.84h72.25v-3.76H15.8v-44.33h88.4v44.33h-16.15v3.76h39.94v-51.84h-32.4ZM5.31,45.36l31.4-31.4,11.37,11.37-31.4,31.4-11.37-11.37Zm118.93,70.25h-16.28v-44.33h16.28v44.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m48.99,93.56c-3.8,0-6.89,2.64-6.89,5.89s3.09,5.89,6.89,5.89,6.89-2.64,6.89-5.89v-21.91h-25.8v20.68c-.94-.41-2-.65-3.13-.65-3.8,0-6.89,2.64-6.89,5.89s3.09,5.89,6.89,5.89,6.89-2.64,6.89-5.89v-14.15h18.28v4.9c-.94-.41-2-.65-3.13-.65Zm0,8.01c-1.7,0-3.13-.97-3.13-2.13s1.43-2.13,3.13-2.13,3.13.97,3.13,2.13-1.43,2.13-3.13,2.13Zm-22.04,4.01c-1.7,0-3.13-.97-3.13-2.13s1.43-2.13,3.13-2.13,3.13.97,3.13,2.13-1.43,2.13-3.13,2.13Zm6.89-20.03v-4.26h18.28v4.26h-18.28Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.01,83.55h38.07v3.76h-38.07v-3.76Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.01,91.56h38.07v3.76h-38.07v-3.76Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.01,99.58h26.05v3.76h-26.05v-3.76Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m21.29,38.08l2.83-2.83,2.66,2.66-2.83,2.83-2.66-2.66Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m26.6,32.77l2.83-2.83,2.66,2.66-2.83,2.83-2.66-2.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvenements);
export default __webpack_public_path__ + "static/media/evenements.56641b58a6ef375fbe21d3e25f08a14f.svg";
export { ForwardRef as ReactComponent };